import React from 'react';
import { SearchIcon } from 'lucide-react';
import { Input } from './ui/Input';
import { Select } from './ui/Select';
import { OrderFilters as OrderFiltersType } from '../types';
export interface OrderFiltersProps {
  filters: OrderFiltersType;
  onFiltersChange: (filters: OrderFiltersType) => void;
}
export function OrderFilters({
  filters,
  onFiltersChange
}: OrderFiltersProps) {
  const orderTypeOptions = [{
    value: 'all',
    label: 'All Types'
  }, {
    value: 'payoff',
    label: 'Payoff'
  }, {
    value: 'insurance',
    label: 'Insurance'
  }, {
    value: 'title',
    label: 'Title'
  }, {
    value: 'appraisal',
    label: 'Appraisal'
  }];
  const statusOptions = [{
    value: 'all',
    label: 'All Statuses'
  }, {
    value: 'ordered',
    label: 'Ordered'
  }, {
    value: 'pending',
    label: 'Pending'
  }, {
    value: 'received',
    label: 'Received'
  }, {
    value: 'reviewed',
    label: 'Reviewed'
  }, {
    value: 'complete',
    label: 'Complete'
  }];
  return <div className="bg-white border border-slate-100 rounded-2xl p-8 shadow-[0_1px_3px_rgba(0,0,0,0.04)]" data-id="element-85">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-86">
        <div className="relative" data-id="element-87">
          <SearchIcon className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-slate-400" data-id="element-88" />
          <input type="text" placeholder="Search orders..." value={filters.search} onChange={e => onFiltersChange({
          ...filters,
          search: e.target.value
        })} className="w-full pl-12 pr-4 py-3 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-transparent transition-all text-slate-900 placeholder:text-slate-400" data-id="element-89" />
        </div>

        <Select options={orderTypeOptions} value={filters.orderType} onChange={e => onFiltersChange({
        ...filters,
        orderType: e.target.value as any
      })} data-id="element-90" />

        <Select options={statusOptions} value={filters.status} onChange={e => onFiltersChange({
        ...filters,
        status: e.target.value as any
      })} data-id="element-91" />

        <Input type="text" placeholder="Assigned to..." value={filters.assignedTo} onChange={e => onFiltersChange({
        ...filters,
        assignedTo: e.target.value
      })} data-id="element-92" />
      </div>
    </div>;
}